import { Component } from '@angular/core';
import { ConfirmationFormData } from '../../models/confirmation-form-data';
import { ModalService } from '../../modules/modal/modal.service';

@Component({
  selector: 'confirmation-modal-form',
  templateUrl: './confirmation-modal-form.component.html',
  styleUrls: ['./confirmation-modal-form.component.css']
})

export class ConfirmationModalFormComponent {
  data: ConfirmationFormData;
  success: Function;
  cancel: Function;
  confirmationInput: string;
    
  constructor(
    protected _modalService: ModalService
  ) {}

  ngOnInit() {
    this.data.confirmationText = 'Fiona';
  }

  onOkClicked(): void {
    if (this.success) {
      this.success();
    }
    this._modalService.closeModal();
  }

  onCancelClicked(): void {
    if (this.cancel) {
      this.cancel();
    }
    this._modalService.closeModal();
  }

  isValidConfirmationInput(): boolean {
    let exp = new RegExp('^' + this.confirmationInput + '$', 'i');
    return exp.test(this.data.confirmationText);
  }
}